import React from "react";
import PropTypes from "prop-types";
import { conditionallyAddStyles } from "../../support/helpers";

const propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  maxLength: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  instruction: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
};

const defaultProps = {
  show: true,
};

const TextInput = ({
  value,
  onChange,
  maxLength,
  title,
  instruction,
  show,
}) => {
  const defaultClasses = ["p-6", "md:block"];

  conditionallyAddStyles(!show, defaultClasses, "hidden")

  return (
    <div className={defaultClasses.join(" ")}>
      <div className="heading-5 uppercase md:heading-4">{title}</div>
      <div className="heading-9 text-grey md:mt-1">{instruction}</div>
      <input
        className="border w-full mt-3 md:mt-7 h-12 p-4 font-bold appearance-none"
        onChange={onChange}
        maxLength={maxLength}
        value={value}
      ></input>
    </div>
  );
};

TextInput.propTypes = propTypes;

TextInput.defaultProps = defaultProps;

export default TextInput;
